import React from 'react';

export function useBeforeUnload({preventNavigation}: {preventNavigation: boolean}) {
  React.useEffect(() => {
    const handleBeforeUnload = (ev: BeforeUnloadEvent) => {
      if (preventNavigation) {
        ev.preventDefault();
      }
    };

    window.addEventListener(`beforeunload`, handleBeforeUnload);
    return () => {
      window.removeEventListener(`beforeunload`, handleBeforeUnload);
    };
  }, [preventNavigation]);
}
